var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144",
    transform: "translate(2807 1100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 140,
    height: 140,
    transform: "translate(-2807 -1100)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2807 -1090)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Badge6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M154.112,137.658c-.028-.947-.04-1.855-.04-2.7,0-4.943.171-9.744.5-14.249H70.42c.334,4.537.513,9.353.513,14.249,0,.8,0,1.664-.036,2.539a51.156,51.156,0,0,0,.736,10.205c11.543-.8,25.824-1.23,40.813-1.23s29.362.454,40.952,1.238A50.878,50.878,0,0,0,154.112,137.658Z",
    transform: "translate(-42.391 -72.665)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M30.4,137.4c.024-.844.032-1.664.032-2.44,0-4.908-.179-9.728-.521-14.249H12.822L9.24,124.292v22.265l4.283,3.546.366-.072a164.4,164.4,0,0,1,17.25-2.066A54.378,54.378,0,0,1,30.4,137.4Z",
    transform: "translate(-5.562 -72.665)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M288.8,137.554a53.262,53.262,0,0,1-.732,10.424,162.092,162.092,0,0,1,17.011,2.034l.362.072,4.3-3.542V124.312l-3.582-3.582H289.284c-.338,4.526-.521,9.354-.521,14.249C288.763,135.779,288.775,136.651,288.8,137.554Z",
    transform: "translate(-173.412 -72.677)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M153.523,55.212A34.588,34.588,0,0,1,139.139,37.85H79.455A34.628,34.628,0,0,1,65.27,55.088,116.91,116.91,0,0,1,67.009,67.16h84.779a115.436,115.436,0,0,1,1.735-11.949Z",
    transform: "translate(-39.291 -22.785)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M75.39,195.842a49.665,49.665,0,0,0,39.647,36.952l.366.068.585-.107a49.671,49.671,0,0,0,39.663-36.9c-11.387-.76-25.434-1.194-40.2-1.194S86.75,195.09,75.39,195.842Z",
    transform: "translate(-45.383 -117.181)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M75.39,195.842a49.665,49.665,0,0,0,39.647,36.952l.366.068.585-.107a49.671,49.671,0,0,0,39.663-36.9c-11.387-.76-25.434-1.194-40.2-1.194S86.75,195.09,75.39,195.842Z",
    transform: "translate(-45.383 -117.181)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M139.127,37.85H79.455A34.628,34.628,0,0,1,65.27,55.088,116.908,116.908,0,0,1,67.009,67.16h84.779a115.425,115.425,0,0,1,1.727-11.941,34.588,34.588,0,0,1-14.388-17.37Z",
    transform: "translate(-39.291 -22.785)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M134.261,61.61H116.19a109.57,109.57,0,0,1,1.783-11.968l.044-.191V47.612l-.935-.525a30.958,30.958,0,0,1-14.209-17.2l-.422-1.254H37.545l-.4,1.254a30.982,30.982,0,0,1-14.13,17.155l-1.194.673.3,1.325A105.45,105.45,0,0,1,24.037,61.61H5.739L0,67.35V92.859L6.981,98.6l2.062-.4a162.011,162.011,0,0,1,17.29-2.046,53.669,53.669,0,0,0,42.652,40.3l1.015.179.314-.056.923-.163a53.7,53.7,0,0,0,42.68-40.256,162.45,162.45,0,0,1,17.051,2.018l2.062.4L140,92.859V67.35Zm2.07,29.5-4.3,3.542-.362-.072a161.041,161.041,0,0,0-17.011-2.034q-1.771-.135-3.65-.267c-11.59-.8-25.915-1.238-40.952-1.238s-29.255.446-40.813,1.23q-1.875.127-3.654.263A162.674,162.674,0,0,0,8.339,94.6l-.366.072-4.3-3.538V68.87l3.582-3.582H132.74l3.582,3.582Z",
    transform: "translate(0 -17.235)",
    fill: "#1e1c55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M140.2,123.86H16.989L13.9,126.9v20.988l3.686,2.989c10.926-2.113,34.895-3.479,61.068-3.479,26.054,0,49.984,1.357,60.961,3.459l3.678-2.989V126.9Z",
    transform: "translate(-8.368 -74.561)",
    fill: "#ff1c3b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    x1: 5.747,
    transform: "translate(38.676 55.066)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M101.177,77.211H98.9V75.87h6.2v1.341h-2.277v5.771h-1.644Z",
    transform: "translate(-59.536 -45.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M122.449,81.661v1.321H116.94V75.87h5.377v1.321h-3.741v1.544h3.3v1.282h-3.3v1.644Z",
    transform: "translate(-70.395 -45.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M133.15,79.237a3.914,3.914,0,0,1,6.786-2.42l-1.055.975a2.279,2.279,0,1,0,0,2.878l1.055.975a3.909,3.909,0,0,1-6.786-2.408Z",
    transform: "translate(-80.153 -45.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M159.764,75.87v7.113h-1.648V80.065h-3.232v2.917H153.24V75.87h1.644v2.786h3.232V75.87Z",
    transform: "translate(-92.247 -45.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M174.12,75.87h1.644v7.113H174.12Z",
    transform: "translate(-104.817 -45.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M189.224,82.983V78.708l-2.094,3.515h-.74L184.3,78.8v4.183H182.76V75.87h1.361l2.655,4.43,2.623-4.422h1.349v7.113Z",
    transform: "translate(-110.018 -45.672)",
    fill: "#ff1c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M213.539,78.449c0,1.592-1.194,2.571-3.089,2.571h-1.433v1.962H207.37V75.87h3.081C212.349,75.87,213.539,76.857,213.539,78.449Zm-1.668,0c0-.8-.505-1.238-1.513-1.238h-1.341v2.468h1.341C211.366,79.679,211.872,79.225,211.872,78.449Z",
    transform: "translate(-124.832 -45.672)",
    fill: "#ff1c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M226.06,75.87H227.7v5.771h3.582v1.341H226.06Z",
    transform: "translate(-136.083 -45.672)",
    fill: "#ff1c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M241.818,80.463v2.519H240.17V80.443l-2.75-4.573h1.747l1.9,3.16,1.9-3.16h1.616Z",
    transform: "translate(-142.922 -45.672)",
    fill: "#ff1c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M165.972,206.05s-.227,5.381.9,7.475a8.477,8.477,0,0,0,2.786,2.858.2.2,0,0,0-.135.183v.275a.2.2,0,0,0,.2.2h.171v2.583l-.482.824h-.541l-.983,1v1.624h-.49v.4h5.97v-.4h-.486v-1.64l-1.023-.983h-.5l-.478-.824h0v-2.583h.1a.2.2,0,0,0,.2-.2v-.275a.191.191,0,0,0-.1-.163,8.541,8.541,0,0,0,2.786-2.878c.9-1.66.939-5.4.915-6.866h0v-.609",
    transform: "translate(-99.9 -124.038)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M167.627,223h5.819v-.227h-.4a.076.076,0,0,1-.076-.076V221.1l-.975-.935h-.474a.076.076,0,0,1-.068-.04l-.474-.816a.068.068,0,0,1,0-.048V216.68a.076.076,0,0,1,.076-.08h.1a.115.115,0,0,0,.115-.115v-.275a.119.119,0,0,0-.056-.1.068.068,0,0,1-.036-.064.076.076,0,0,1,.032-.064,8.549,8.549,0,0,0,2.786-2.85c.884-1.64.927-5.322.908-6.826v-.545a28.065,28.065,0,0,0-8.657,0c0,.609-.143,5.441.9,7.371a8.334,8.334,0,0,0,2.746,2.83.072.072,0,0,1,.036.076.088.088,0,0,1-.056.064.111.111,0,0,0-.084.107v.275a.119.119,0,0,0,.119.115h.171a.08.08,0,0,1,.076.08v2.583a.068.068,0,0,1,0,.04l-.478.824a.084.084,0,0,1-.068.04h-.557l-.939.951v1.592a.08.08,0,0,1-.076.076h-.4Z",
    transform: "translate(-100.075 -123.662)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M189.505,206.972a1.644,1.644,0,0,0-2.2.9,1.52,1.52,0,0,0,0,1.194,1.329,1.329,0,0,0,.8.7.207.207,0,0,0,.267-.131.211.211,0,0,0-.131-.267.931.931,0,0,1-.513-.4,1.262,1.262,0,0,1-.044-.446,1.194,1.194,0,0,1,.028-.2.979.979,0,0,1,.947-.669,1.075,1.075,0,0,1,.971.915,3.061,3.061,0,0,1-.048,1.66,5.97,5.97,0,0,1-1.568,1.851l-.33.271-.267.2a2.575,2.575,0,0,0-.975,1.051,1.329,1.329,0,0,0,.068,1.13,1.083,1.083,0,0,0,.939.581,1.054,1.054,0,0,0,.354-.056.947.947,0,0,0,.712-1.114.211.211,0,1,0-.4.131c.1.287-.263.517-.45.585a.637.637,0,0,1-.772-.326.9.9,0,0,1-.052-.768,2.245,2.245,0,0,1,.836-.872l.279-.207c.115-.092.231-.183.342-.279a5.248,5.248,0,0,0,1.99-2.914C190.393,209.018,190.636,207.406,189.505,206.972Z",
    transform: "translate(-112.174 -124.506)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M188.771,207.706h.024c.5,0,.88.362,1.047.971a3.152,3.152,0,0,1-.052,1.7h0a6.046,6.046,0,0,1-1.592,1.875l-.334.271c-.088.068-.175.135-.267.2a2.535,2.535,0,0,0-.951,1.019,1.234,1.234,0,0,0,.068,1.063.983.983,0,0,0,.868.541h0a.888.888,0,0,0,.322-.056.872.872,0,0,0,.665-1.015.135.135,0,0,0-.068-.08.143.143,0,0,0-.1,0,.135.135,0,0,0-.08.068.131.131,0,0,0,0,.1c.107.33-.251.593-.5.681a.709.709,0,0,1-.864-.362.971.971,0,0,1-.056-.832,2.257,2.257,0,0,1,.86-.9l.279-.207c.123-.1.235-.187.342-.279a5.388,5.388,0,0,0,1.99-2.87c.1-.47.334-2.03-.74-2.444h0a1.592,1.592,0,0,0-2.1.852,1.445,1.445,0,0,0,0,1.15,1.254,1.254,0,0,0,.76.665.135.135,0,0,0,.1,0,.139.139,0,0,0,.068-.076.135.135,0,0,0-.088-.171,1,1,0,0,1-.553-.43h0a1.429,1.429,0,0,1-.048-.47,1,1,0,0,1,1.031-.947Z",
    transform: "translate(-112.303 -124.623)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M161.45,213.64a2.575,2.575,0,0,0-.975-1.051l-.267-.2-.33-.271a5.971,5.971,0,0,1-1.568-1.851,3.061,3.061,0,0,1-.048-1.66,1.075,1.075,0,0,1,.975-.915.979.979,0,0,1,.943.669.891.891,0,0,1,.028.2,1.261,1.261,0,0,1-.044.446.935.935,0,0,1-.509.4.211.211,0,1,0,.135.4,1.322,1.322,0,0,0,.8-.7,1.52,1.52,0,0,0,0-1.194,1.644,1.644,0,0,0-2.2-.9c-1.13.434-.888,2.046-.8,2.531a5.331,5.331,0,0,0,1.99,2.914c.111.1.227.187.342.279l.279.207a2.217,2.217,0,0,1,.836.872.9.9,0,0,1-.052.768.637.637,0,0,1-.772.326c-.187-.068-.545-.3-.45-.585a.211.211,0,1,0-.4-.131.947.947,0,0,0,.712,1.114,1.056,1.056,0,0,0,.346.06,1.083,1.083,0,0,0,.939-.581,1.329,1.329,0,0,0,.088-1.146Z",
    transform: "translate(-94.813 -124.531)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M159.721,214.172a.16.16,0,0,0-.06,0,.135.135,0,0,0-.068.08.872.872,0,0,0,.665,1.015.915.915,0,0,0,.322.056h0a.991.991,0,0,0,.872-.541,1.246,1.246,0,0,0,.064-1.063h0a2.555,2.555,0,0,0-.947-1.019c-.1-.068-.187-.131-.271-.2l-.334-.271a6.047,6.047,0,0,1-1.592-1.875h0a3.152,3.152,0,0,1-.052-1.7,1.137,1.137,0,0,1,1.047-.971.975.975,0,0,1,1.055.943,1.421,1.421,0,0,1-.048.47h0a1,1,0,0,1-.553.43.131.131,0,0,0-.084.171.127.127,0,0,0,.068.076.123.123,0,0,0,.1,0,1.254,1.254,0,0,0,.76-.665,1.445,1.445,0,0,0,0-1.15,1.592,1.592,0,0,0-2.1-.852c-1.075.4-.836,1.99-.74,2.444a5.175,5.175,0,0,0,1.99,2.87l.338.279.279.207a2.257,2.257,0,0,1,.86.9.971.971,0,0,1-.056.832.709.709,0,0,1-.864.362c-.251-.088-.609-.35-.5-.681a.131.131,0,0,0,0-.1.139.139,0,0,0-.076-.068Z",
    transform: "translate(-94.951 -124.593)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 1.027,
    height: 3.598,
    transform: "translate(71.071 85.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M171.43,213.01v.836h1.417v3.6h1.027v-3.6h.394v-.836Z",
    transform: "translate(-103.197 -128.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 1.027,
    height: 0.836,
    transform: "translate(71.071 84.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 1.027,
    height: 0.836,
    transform: "translate(71.071 83.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M209.1,256.267l.462-1.707-1.377-1.11,1.767-.088.629-1.652.633,1.652,1.767.088-1.381,1.11.466,1.707-1.485-.967Z",
    transform: "translate(-125.32 -151.524)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M235.835,236.166l.295-1.087-.88-.708,1.126-.056.4-1.055.4,1.055,1.126.056-.88.708.294,1.087-.935-.621Z",
    transform: "translate(-141.615 -140.418)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M254.018,212.166l.2-.744-.6-.482.772-.04.275-.72.271.72.772.04-.6.482.2.744-.645-.422Z",
    transform: "translate(-152.674 -126.524)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M171.528,268.521l-2.468-.08,1.9-1.592-.689-2.388,2.09,1.313,2.046-1.385-.605,2.388,1.95,1.516-2.464.163-.84,2.324Z",
    transform: "translate(-101.771 -159.157)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M136.646,255.3l-1.481.967.462-1.707-1.377-1.11,1.767-.088.629-1.652.633,1.652,1.767.088-1.381,1.11.466,1.707Z",
    transform: "translate(-80.816 -151.524)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M113.066,235.545l-.951.621.295-1.087-.88-.708,1.126-.056.4-1.055.4,1.055,1.126.056-.872.708.295,1.087Z",
    transform: "translate(-67.139 -140.418)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M96.653,211.744l-.645.422.2-.744-.6-.482.772-.04.271-.72.275.72.772.04-.6.482.2.744Z",
    transform: "translate(-57.555 -126.524)",
    fill: "#ffbd3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M42.713,147.785H40.89V146.71h4.967v1.075H44.034V152.4H42.713Z",
    transform: "translate(-24.615 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M54,149.405a3.121,3.121,0,1,1,3.117,2.945A2.947,2.947,0,0,1,54,149.405Zm4.9,0a1.783,1.783,0,1,0-1.779,1.823,1.735,1.735,0,0,0,1.8-1.823Z",
    transform: "translate(-32.507 -88.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M77.129,148.776c0,1.27-.951,2.058-2.476,2.058H73.507v1.592H72.19V146.71h2.464C76.178,146.71,77.129,147.5,77.129,148.776Zm-1.337,0c0-.625-.4-.991-1.194-.991H73.507v1.99h1.075C75.386,149.759,75.792,149.393,75.792,148.776Z",
    transform: "translate(-43.457 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M92,149.4a3.136,3.136,0,0,1,5.437-1.934l-.848.8a1.829,1.829,0,1,0-1.429,2.977,1.811,1.811,0,0,0,1.429-.673l.848.8a2.917,2.917,0,0,1-2.352,1.015A2.974,2.974,0,0,1,92,149.4Z",
    transform: "translate(-55.382 -88.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M107.67,149.9V146.72H109v3.14c0,1.083.474,1.528,1.27,1.528s1.27-.446,1.27-1.528v-3.14h1.3V149.9a2.583,2.583,0,1,1-5.166,0Z",
    transform: "translate(-64.815 -88.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M122.77,151.692l.45-1a3.336,3.336,0,0,0,1.879.6c.8,0,1.1-.263,1.1-.613,0-1.067-3.312-.33-3.312-2.448,0-.967.8-1.775,2.388-1.775a3.817,3.817,0,0,1,1.99.505l-.4,1a3.244,3.244,0,0,0-1.592-.446c-.8,0-1.083.295-1.083.653,0,1.047,3.312.322,3.312,2.416,0,.951-.8,1.763-2.416,1.763A4.072,4.072,0,0,1,122.77,151.692Z",
    transform: "translate(-73.905 -88.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M136.943,147.785H135.12V146.71h4.963v1.075h-1.827V152.4h-1.313Z",
    transform: "translate(-81.339 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M148.26,149.405a3.121,3.121,0,1,1,3.117,2.945A2.948,2.948,0,0,1,148.26,149.405Zm4.9,0a1.783,1.783,0,1,0-1.783,1.823,1.739,1.739,0,0,0,1.783-1.823Z",
    transform: "translate(-89.249 -88.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M171.608,152.4v-3.419l-1.676,2.818h-.6l-1.668-2.742V152.4H166.43V146.71h1.091l2.133,3.538,2.1-3.538h1.079l.02,5.7Z",
    transform: "translate(-100.187 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M190.59,151.692l.45-1a3.335,3.335,0,0,0,1.879.6c.8,0,1.1-.263,1.1-.613,0-1.067-3.312-.33-3.312-2.448,0-.967.8-1.775,2.388-1.775a3.817,3.817,0,0,1,1.99.505l-.4,1a3.244,3.244,0,0,0-1.592-.446c-.8,0-1.083.295-1.083.653,0,1.047,3.312.322,3.312,2.416,0,.951-.8,1.763-2.416,1.763A4.072,4.072,0,0,1,190.59,151.692Z",
    transform: "translate(-114.731 -88.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M203.86,149.405a3.121,3.121,0,1,1,3.116,2.945A2.947,2.947,0,0,1,203.86,149.405Zm4.9,0a1.783,1.783,0,1,0-1.783,1.823,1.739,1.739,0,0,0,1.783-1.823Z",
    transform: "translate(-122.719 -88.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M223.321,147.769v1.5h2.635v1.059h-2.635V152.4H222V146.71h4.3v1.059Z",
    transform: "translate(-133.639 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M235.383,147.785H233.56V146.71h4.951v1.075h-1.823V152.4h-1.317Z",
    transform: "translate(-140.598 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M255.4,146.7l-1.863,5.688h-1.417l-1.254-3.857-1.294,3.857h-1.405l-1.871-5.7h1.365l1.3,4.012,1.341-4h1.222l1.3,4.036,1.309-4.036Z",
    transform: "translate(-148.267 -88.304)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M273.143,151.2H270.5l-.537,1.194H268.61l2.543-5.688h1.3l2.559,5.688h-1.381Zm-.4-1-.935-2.185-.9,2.181Z",
    transform: "translate(-161.697 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M289.82,152.4l-1.1-1.592h-1.214V152.4H286.19V146.71h2.464c1.524,0,2.476.8,2.476,2.066a1.851,1.851,0,0,1-1.17,1.8l1.278,1.831Zm-1.238-4.621h-1.075v1.99h1.075c.8,0,1.214-.374,1.214-.991s-.41-.991-1.214-.991Z",
    transform: "translate(-172.28 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M305.62,151.347V152.4h-4.41V146.71H305.5v1.059H302.52V149h2.647v1.027H302.52v1.317Z",
    transform: "translate(-181.322 -88.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M70.78,167.022a49.665,49.665,0,0,0,39.627,36.952l.366.068.585-.1a49.649,49.649,0,0,0,39.663-36.9c-11.387-.76-25.434-1.194-40.2-1.194S82.136,166.27,70.78,167.022Z",
    transform: "translate(-42.608 -99.832)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M115.968,232.737l-.585.107-.366-.068A49.665,49.665,0,0,1,75.39,195.824c11.36-.752,25.342-1.194,40.049-1.194s28.8.434,40.2,1.194A49.721,49.721,0,0,1,115.968,232.737Z",
    transform: "translate(-45.383 -117.163)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M139.127,37.85H122.832a13.656,13.656,0,0,1-13.015,9.529h0A13.648,13.648,0,0,1,96.805,37.85H79.455A34.628,34.628,0,0,1,65.27,55.088,116.908,116.908,0,0,1,67.009,67.16h84.779a115.425,115.425,0,0,1,1.727-11.941,34.588,34.588,0,0,1-14.388-17.37Z",
    transform: "translate(-39.291 -22.785)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M160.624,0a10.95,10.95,0,1,0,10.946,10.942A10.95,10.95,0,0,0,160.624,0Z",
    transform: "translate(-90.098 0)",
    fill: "#ff1c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M170.071,17.85h-6.2v1.827h3.1v7.865h2.245V19.677h.856v7.865h2.245V17.85Z",
    transform: "translate(-98.646 -10.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 2.245,
    height: 1.827,
    transform: "translate(71.425 4.577)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.103f6abda7f2e699433f6ad7e2f8f7f5.svg";
export { ForwardRef as ReactComponent };